export const colors = {
  'action-primary': '#b05567',
  'action-primary-hovered': '#883a4a',
  'action-primary-pressed': '#6b2a38',
  'action-primary-subdued': '#6b2a38',
  'action-primary-subdued-hovered': '#883a4a',
  'action-primary-subdued-pressed': '#883a4a',
  'action-primary-disabled': '#41403f',
  'action-neutral': '#171717',
  'action-neutral-hovered': '#292828',
  'action-neutral-pressed': '#41403f',
  'action-neutral-subdued': '#292828',
  'action-neutral-subdued-hovered': '#41403f',
  'action-neutral-subdued-pressed': '#41403f',
  'action-neutral-disabled': '#292828',
  'action-destructive': '#bc5044',
  'action-destructive-hovered': '#90372e',
  'action-destructive-pressed': '#712821',
  'action-destructive-subdued': '#4a1712',
  'action-destructive-subdued-hovered': '#712821',
  'action-destructive-subdued-pressed': '#90372e',
  'action-destructive-disabled': '#41403f',
  background: '#292828',
  'background-hovered': '#41403f80',
  'background-pressed': '#41403f',
  'background-selected': '#41403f',
  'background-backdrop': '#00000080',
  'background-overlay': '#00000080',
  'background-divider': '#a2a29f',
  content: '#f9f8f5',
  'content-subdued': '#d5d4d1',
  'content-muted': '#a2a29f',
  'content-hovered': '#f4f3f0',
  'content-pressed': '#d5d4d1',
  'content-disabled': '#737270',
  'content-on-positive': '#cceed6',
  'content-on-attention': '#ffe1c3',
  'content-on-highlight': '#d8e7ff',
  'content-on-negative': '#ffdfda',
  'content-on-negative-hovered': '#ffc6bd',
  'content-on-negative-pressed': '#ffc6bd',
  'content-primary': '#fcf0f1',
  'content-on-primary': '#FFFFFF',
  'content-on-inverse': '#171717',
  'content-on-destructive': '#f9f8f5',
  'content-on-interactive': '#f9f8f5',
  'content-on-background': '#f9f8f5',
  'content-on-background-subdued': '#d5d4d1',
  'content-on-background-hovered': '#f4f3f0',
  'content-on-background-pressed': '#d5d4d1',
  'content-on-background-disabled': '#737270',
  interactive: '#b05567',
  'interactive-hovered': '#883a4a',
  'interactive-pressed': '#6b2a38',
  'interactive-disabled': '#171717',
  'interactive-destructive': '#bc5044',
  'interactive-destructive-hovered': '#90372e',
  'interactive-destructive-pressed': '#712821',
  'interactive-destructive-disabled': '#171717',
  topbar: '#171717',
  'topbar-subdued': '#292828',
  'content-on-topbar': '#f9f8f5',
  'line-on-topbar': '#54545380',
  'line-on-topbar-pressed': '#737270',
  link: '#f4c9ce',
  'link-hovered': '#dd8b97',
  'link-pressed': '#b05567',
  line: '#54545380',
  'line-subdued': '#41403f',
  'line-hovered': '#545453',
  'line-pressed': '#737270',
  'line-selected': '#545453',
  'line-disabled': '#41403f',
  'line-transparent': '#ffffff1a',
  'line-positive': '#051b0e',
  'line-positive-subdued': '#051b0e',
  'line-highlight': '#08162f',
  'line-highlight-subdued': '#08162f',
  'line-negative': '#2f0b08',
  'line-negative-subdued': '#2f0b08',
  'line-negative-disabled': '#712821',
  'line-attention': '#241304',
  'line-attention-subdued': '#241304',
  focused: '#b05567',
  skeleton: '#41403f',
  surface: '#171717',
  'surface-subdued': '#292828',
  'surface-hovered': '#292828',
  'surface-subdued-hovered': '#41403f',
  'surface-pressed': '#41403f',
  'surface-disabled': '#292828',
  'surface-selected': '#6b2a38',
  'surface-selected-hovered': '#883a4a',
  'surface-selected-pressed': '#883a4a',
  'surface-attention': '#5b38144d',
  'surface-attention-subdued': '#3c220a4d',
  'surface-negative': '#7128214d',
  'surface-negative-subdued': '#4a17124d',
  'surface-negative-subdued-hovered': '#2f0b084d',
  'surface-negative-subdued-pressed': '#2f0b084d',
  'surface-positive': '#17492d4d',
  'surface-positive-subdued': '#0b2e1a4d',
  'surface-highlight': '#213f734d',
  'surface-highlight-subdued': '#12274c4d',
  'surface-highlight-subdued-hovered': '#08162f4d',
  'surface-highlight-subdued-pressed': '#08162f4d',
  'surface-neutral': '#545453',
  'surface-neutral-subdued': '#41403f',
  'surface-inverse': '#f9f8f5',
  'decorative-surface-1': '#FFC96B',
  'decorative-surface-1-subdued': '#FFE4B5',
  'decorative-content-1': '#7E5700',
  'decorative-surface-2': '#FFC4B0',
  'decorative-surface-2-subdued': '#FFE1D7',
  'decorative-content-2': '#AF294E',
  'decorative-surface-3': '#92E6B5',
  'decorative-surface-3-subdued': '#C9F3DA',
  'decorative-content-3': '#006D41',
  'decorative-surface-4': '#91E0D6',
  'decorative-surface-4-subdued': '#C8EFEB',
  'decorative-content-4': '#006A68',
  'decorative-surface-5': '#FDC9D0',
  'decorative-surface-5-subdued': '#FEE4E7',
  'decorative-content-5': '#AE2B4C',
  'decorative-surface-6': '#7CD4FD',
  'decorative-surface-6-subdued': '#BDE9FE',
  'decorative-content-6': '#065986',
  'decorative-surface-7': '#BDB4FE',
  'decorative-surface-7-subdued': '#DED9FF',
  'decorative-content-7': '#4A1FB8',
}
